module.exports = __webpack_public_path__ + "img/report.2a8d4678.png";